import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DateFilterModel } from './date-filter.model';
import * as moment from 'moment/moment';

import { DateType } from './date-type.model';
import { TimeFormatInterval } from '../../shared/timepicker/time-picker-interval';
 // Override Date object formatter
import { Ng2Datetime } from 'ng2-datetime-picker';
Ng2Datetime.formatDate = (date: Date, format: string): string => {
    return moment(date).format(format);
};

// Override Date object parser
Ng2Datetime.parseDate = (str: any): Date => {
    return moment(str).toDate();
};

@Component({
    selector: 'datepicker-list',
    templateUrl: './datepicker-list.component.html',
    styleUrls: ['./datepicker-list.component.css']
})
export class DatepickerListComponent implements OnInit {
    @Output() submit = new EventEmitter<DateFilterModel>();
    @Output() reset = new EventEmitter();

    tooltip: string;

    _dateFilters: DateFilterModel[];
    get dateFilters(): DateFilterModel[] {
        return this._dateFilters;
    }
    @Input()
    set dateFilters(value: DateFilterModel[]) {
        this._dateFilters = value;
        this.showList = this._dateFilters.length > 1;
        if (this.showList) {
            this._dateFilters.unshift(new DateFilterModel());
        }
        this.activeDateFilter = this._dateFilters[0];
    }
    @Input() disableReset = false;
    @Input() timeInterval;

    activeDateFilter: DateFilterModel;
    showList: boolean;

    get isValid(): boolean {
        if (!this.activeDateFilter || !this.activeDateFilter.startDate || !this.activeDateFilter.endDate) {
            return false;
        }

        this.tooltip = '';
        const dtStartDateTime = new Date(`${moment(this.activeDateFilter.startDate).format('M/D/YYYY')}
            ${this.activeDateFilter.startTime ? this.activeDateFilter.startTime : ''}`);
        const dtEndDateTime = new Date(`${moment(this.activeDateFilter.endDate).format('M/D/YYYY')}
            ${this.activeDateFilter.endTime ? this.activeDateFilter.endTime : ''}`);

        if (!this.isValidDate(dtStartDateTime) || !this.isValidDate(dtEndDateTime)) {
            if (!this.isValidDate(this.activeDateFilter.startDate) && !this.isValidDate(this.activeDateFilter.endDate)) {
                this.tooltip = 'Please enter a valid Start date and a valid End date';
                return false;
            }

            if (!this.isValidDate(dtStartDateTime) && !this.isValidDate(dtEndDateTime)) {
                this.tooltip = 'Please enter a valid Start time and a valid End time';
                return false;
            }

            if (!this.isValidDate(this.activeDateFilter.startDate)) {
                this.tooltip = 'Please enter a valid Start Date';
                return false;
            }

            if (!this.isValidDate(dtStartDateTime)) {
                this.tooltip = 'Please enter a valid Start time';
                return false;
            }

            if (!this.isValidDate(this.activeDateFilter.endDate)) {
                this.tooltip = 'Please enter a valid End Date';
                return false;
            }

            if (!this.isValidDate(dtEndDateTime)) {
                this.tooltip = 'Please enter a valid End time';
                return false;
            }
        } else {
            if (moment(dtEndDateTime) < moment(dtStartDateTime)) {
                this.tooltip = 'End Date cannot be earlier than Start Date';
                return false;
            } else {
                return true;
            }
        }
    }

    _defaultEndDate: Date;
    get defaultEndDate(): Date {
        if (this.isValidDate(this.activeDateFilter.endDate)) {
            this._defaultEndDate = this.activeDateFilter.endDate;
        } else {
            this._defaultEndDate = new Date();
        }

        return this._defaultEndDate;
    }

    _defaultStartDate: Date;
    get defaultStartDate(): Date {
        if (this.isValidDate(this.activeDateFilter.startDate)) {
            this._defaultStartDate = this.activeDateFilter.startDate;
        } else {
            this._defaultStartDate = new Date();
        }

        return this._defaultStartDate;
    }

    constructor() { }

    ngOnInit() {
    }

    onTimeChanged(dateType: DateType, value: string) {
        if (dateType === DateType.Start) {
            this.activeDateFilter.startTime = value;
        } else {
            this.activeDateFilter.endTime = value;
        }
    }

    private isValidDate(date: Date): boolean {
        let valid = false;
        if (date) {
            const temp = moment(date);
            valid = temp.isValid();
        }

        return valid;
    }

    onSubmit(): void {
        if (this.isValid) {
            let startDateString = moment(this.activeDateFilter.startDate).format('M/D/YYYY');
            let endDateString = moment(this.activeDateFilter.endDate).format('M/D/YYYY');

            if (!this.activeDateFilter.startTime && this.timeInterval.length > 5) {
                this.activeDateFilter.startTime = `${TimeFormatInterval.TimeRangeMinimumSeconds}`;
            }
            if (this.activeDateFilter.startTime) {
                startDateString = `${startDateString} ${this.activeDateFilter.startTime}`;
            }

            if (!this.activeDateFilter.endTime && this.timeInterval.length > 5) {
                this.activeDateFilter.endTime = `${TimeFormatInterval.TimeRangeMinimumSeconds}`;
            }
            if (this.activeDateFilter.endTime) {
                endDateString = `${endDateString} ${this.activeDateFilter.endTime}`;
            }

            this.activeDateFilter.dateRange = `${startDateString}to${endDateString}`;

            this.submit.emit(this.activeDateFilter);
        }
    }

    onReset(): void {
        // expose event to feed-grid component, which will reset the criteria completley
        this.reset.emit();
    }

    selectChanged(): void {
        this.resetFilters(false);
    }

    private resetFilters(all: boolean) {
        this.dateFilters.forEach(filter => {

            if (!all && filter.fieldName !== this.activeDateFilter.fieldName) {
                filter.dateRange = null;
                filter.endDate = null;
                filter.startDate = null;
                filter.startTime = null;
                filter.endTime = null;
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker-list/datepicker-list.component.ts